import React from 'react';
import styled from '@emotion/styled';

const StyledInput = styled.input`
  border: 0;
  padding: 0;
  font-size: 16px;
  width: 100%;
`;

const handleClick = (e: { target: HTMLInputElement } & Event) => {
  e.target.select(); // HTMLInputElement.setSelectionRange() doesn't work in some desktop browsers
  e.target.setSelectionRange(0, e.target.value.length); // HTMLInputElement.select() doesn't work on iOS
};

export default (props: any) => <StyledInput {...props} readOnly onClick={handleClick} />;
